import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const CloudServices = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Cloud Services</h1>
            <p className="service-description">
              Modern cloud solutions to transform your business operations 
              with scalable, secure, and cost-effective infrastructure.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Cloud Solutions</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">☁️</div>
                    <h3>Cloud Migration</h3>
                  </div>
                  <p>Seamless migration of your existing infrastructure to cloud platforms like AWS, Azure, or Google Cloud.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Cloud Migration</div>
                    <ul className="popover-list">
                      <li>Assessment, TCO and migration strategy</li>
                      <li>Landing zone and account setup</li>
                      <li>Lift‑and‑shift, replatform or refactor</li>
                      <li>Database and file migration tooling</li>
                      <li>Cutover planning and rollback</li>
                      <li>Knowledge transfer and docs</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📊</div>
                    <h3>Cloud Monitoring</h3>
                  </div>
                  <p>Comprehensive monitoring and management of your cloud resources for optimal performance.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Cloud Monitoring</div>
                    <ul className="popover-list">
                      <li>Metrics, logs and traces (observability)</li>
                      <li>SLO/SLA dashboards and alerts</li>
                      <li>Autoscaling and capacity planning</li>
                      <li>Cost monitoring and optimization</li>
                      <li>Health checks and remediation</li>
                      <li>Runbooks and escalation paths</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔄</div>
                    <h3>Backup Solutions</h3>
                  </div>
                  <p>Automated cloud backup solutions with disaster recovery and business continuity planning.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Backup Solutions</div>
                    <ul className="popover-list">
                      <li>Policy design: RPO/RTO objectives</li>
                      <li>Cross‑region/cross‑account backups</li>
                      <li>Immutable storage and lifecycle rules</li>
                      <li>DR runbooks and failover testing</li>
                      <li>Backup monitoring and reporting</li>
                      <li>Compliance and encryption</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔒</div>
                    <h3>Cloud Security</h3>
                  </div>
                  <p>Implementation of cloud security best practices and compliance frameworks.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Cloud Security</div>
                    <ul className="popover-list">
                      <li>IAM least‑privilege and SSO integration</li>
                      <li>Network segmentation and WAF</li>
                      <li>Key management and encryption at rest/in transit</li>
                      <li>Security baselines and guardrails</li>
                      <li>Compliance mapping (ISO/NIST/PCI)</li>
                      <li>Continuous security scanning</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Cloud Benefits</h2>
                <ul className="benefits-list">
                  <li>✓ Reduced infrastructure costs</li>
                  <li>✓ Scalability on demand</li>
                  <li>✓ Enhanced collaboration capabilities</li>
                  <li>✓ Automatic updates and maintenance</li>
                  <li>✓ Global accessibility</li>
                  <li>✓ Improved disaster recovery</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Platforms:</span>
                  <span className="highlight-value">Multi-cloud</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Migration:</span>
                  <span className="highlight-value">Zero Downtime</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Support:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default CloudServices;
